import DragAndDropArea from './DragAndDropArea';

export default DragAndDropArea;
